<template>
  <a-drawer
    :title="`自动应用(${record.projectName})`"
    placement="right"
    :visible="visible"
    width="480px"
    :mask-closable="false"
    class="auto-application"
    @close="onClose"
  >
    <a-form-model ref="autoForm" :model="form" :colon="false">
      <block-title
        title="下单方式"
        class="block"
        :show-line="false"
      >
        <a-form-model-item :colon="false" prop="type">
          <a-select
            v-model="form.type"
            placeholder="请选择下单方式"
            style="width: 100%"
            :options="CreateTypeList"
            :get-popup-container="triggerNode => triggerNode.parentNode"
          />
        </a-form-model-item>
      </block-title>
      <block-title
        title="应用条件"
        class="block"
        :show-line="false"
      >
        <div class="bloc-tips">
          <a-icon type="info-circle" />
          当订单符合以下任一条件，此订单自动使用所选的运营项目
        </div>
        <a-form-model-item :colon="false" label="仓货主（仓配一体）">
          <a-select
            v-model="form.contentValue.customerValue"
            mode="multiple"
            allow-clear
            :max-tag-count="1"
            :filter-option="filterOption"
            style="width: 100%"
            placeholder="选择仓货主"
            :get-popup-container="triggerNode => triggerNode.parentNode"
          >
            <a-select-option
              v-for="item in warehouseCustomerList"
              :key="item.code"
              :disabled="item.isChecked"
              :value="item.code"
            >
              {{ item.code }}({{item.name}})-{{item.tenantName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false" label="仓库（仓配一体）">
          <a-select
            v-model="form.contentValue.warehouseValue"
            mode="multiple"
            allow-clear
             :max-tag-count="1"
            :filter-option="filterOption"
            style="width: 100%"
            placeholder="选择仓库"
            :get-popup-container="triggerNode => triggerNode.parentNode"
          >
            <a-select-option
              v-for="item in warehouseList"
              :key="item.code"
              :disabled="item.isChecked"
              :value="item.code"
            >
              {{ item.code }}({{item.name}})
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false" label="区域">
          <a-button @click="clickErea">选择区域({{areaValue.length}})</a-button>
        </a-form-model-item>
        <a-form-model-item :colon="false" label="站点">
          <a-select
            v-model="form.contentValue.stationValue"
            mode="multiple"
            allow-clear
             :max-tag-count="1"
             :filter-option="false"
            show-search
            style="width: 100%"
            placeholder="选择站点"
             :get-popup-container="triggerNode => triggerNode.parentNode"
            @search="handleStationSearch"
            @deselect="(value)=>handleDeselect(value,'siteList','selectSiteList')"
            @select="(value)=>handleSelect(value,'siteList','selectSiteList')"
          >
            <a-select-option
              v-for="item in siteList"
              :key="item.code"
              :disabled="item.isChecked"
              :value="item.code"
            >
              {{ item.code }}({{item.name}})
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false" label="线路">
          <a-select
            v-model="form.contentValue.lineValue"
            mode="multiple"
            allow-clear
             :max-tag-count="1"
            :filter-option="filterOption"
            style="width: 100%"
            placeholder="选择线路"
             :get-popup-container="triggerNode => triggerNode.parentNode"
              @search="handleLineSearch"
            @deselect="(value)=>handleDeselect(value,'lineList','selectLineList')"
            @select="(value)=>handleSelect(value,'lineList','selectLineList')"
          >
            <a-select-option
              v-for="item in lineList"
              :key="item.code"
              :disabled="item.isChecked"
              :value="item.code"
            >
              {{ item.code }}-{{item.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false" label="SKU">
          <a-select
            v-model="form.contentValue.skuValue"
            mode="multiple"
            allow-clear
             :max-tag-count="1"
            :filter-option="false"
            show-search
            style="width: 100%"
            placeholder="选择SKU"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @search="handleSkuSearch"
             @deselect="(value)=>handleDeselect(value,'skuList','selectSkuList')"
            @select="(value)=>handleSelect(value,'skuList','selectSkuList')"
          >
            <a-select-option
              v-for="item in skuList"
              :key="item.code"
              :disabled="item.isChecked"
              :value="item.code"
            >
              {{ item.code }}-{{item.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </block-title>
    </a-form-model>
    <div
      class="drawer-bottom"
    >
      <a-button :style="{ marginRight: '12px' }" @click="onClose">
        取消
      </a-button>
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </div>
    <station-drawer ref="stationDrawer" @changeErea="changeErea" />
  </a-drawer>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import {getWareHouse} from '@/pages/warehouseOrder/api'
import {getSignType} from '@/api/enterprise/authentication'
import { mapMutations } from 'vuex'
import { CreateTypeList } from '../constant'
import StationDrawer from './StationDrawer.vue'
import { upsertProjectContent, getProjectContentDetail, fetchSkuPage, fetchStationPage,customerLineList } from '../api'

export default {
  name: 'AutoApplication',
  components: {
    BlockTitle,
    StationDrawer,
  },
  data() {
    return {
      visible: false,
      record: {},
      form: {
        type: CreateTypeList[0].value,
        contentValue: {}
      },
      CreateTypeList,
      warehouseCustomerList: [],
      warehouseList: [],
      siteList: [],
      lineList: [],
      skuList: [],
      areaValue: [], // 区域
      requireList: ['customerValue', 'warehouseValue', 'stationValue', 'lineValue', 'skuValue'],
      contentValueList: {
        customerValue: 'warehouseCustomerList',
        warehouseValue: 'warehouseList',
        stationValue: 'selectSiteList',
        lineValue: 'selectLineList',
        skuValue: 'selectSkuList'
      },
      selectSiteList:[],
      selectLineList:[],
      selectSkuList:[],
      TenantList: [],
    }
  },
  async created() {
    const { customers } =this.$store.state.user
    const params = customers.map(item=>item.customerId)
    const res = await getSignType({
      ids: params,
    })
    this.TenantList=res
  },
  methods: {
    ...mapMutations('user', ['SET_USER_DATA']),
    handleDeselect(value,prop,selectProp){
      this[selectProp].splice(this[selectProp].findIndex(item=>item.code===value),1)
    },
    handleSelect(value,prop,selectProp){
      const select =  this[prop].find(item=>item.code===value)
      this[selectProp].push(select)
    },
    async getWarehouseCustomer() {
      const data = await this.getWareHouse({needProjectContentCheck:true})
      this.warehouseCustomerList = data.map(item=>({...item,code:item.shipperCode,name:item.shipperName}))
    },
    async getWarehouseList() {
      const data = await this.getWareHouse({needProjectContentCheck:true,searchWarehouse:true})
      this.warehouseList = data.map(item=>({...item,code:item.tenantId,name:item.tenantName}))
    },
    async getWareHouse(params){
      const data ={
        ...params,
        neProjectId:this.record.id,
        customerCode: this.record.customerCode,
        loginCustomerCode: this.record.customerCode,
        needExcludeDefaultTenant: true,
        type: "STORE",
        needGroupByTenantId: false,
      }
      const res = await getWareHouse({...data},{size:1000})
      return res.records
    }, 
    handleStationSearch(query){
      this.getSiteList(query)
    },
    async getSiteList(query=null) {
      const res = await fetchStationPage({
        multiLike:query || null,
        needProjectContentCheck: true,
        stationType: "RECEIVING",
        status: "ENABLED",
        bizTypes: [ "TRANSPORT","TRANSPORT_WAREHOUSE"],
        loginCustomerCode: this.record.customerCode,
        deleteStatus: false,
        customerCodes: this.warehouseCustomerList.length?this.warehouseCustomerList.map(item=>item.code):[],
        neProjectId:this.record.id,
      })
      this.siteList = res.records.map(item => {
        return {
          ...item,
          code: item.stationCode,
          name: item.stationName
        }
      })
    },
    handleLineSearch(query){
      this.getLineList(query)
    },
    async getLineList(query=null) {
      const res = await customerLineList({
        lineNameLike:query || null,
        customerCode:this.record.customerCode,
        createTenantId:this.record.tenantId,
        needProjectContentCheck:true,
        neProjectId:this.record.id,
        lineStatus: "ENABLED",
        needStation: true,
        stationStatus: "ENABLED"
      })
      this.lineList = res.records.map(item => {
        return {
          ...item,
          code: item.lineCode,
          name: item.lineName
        }
      })
    },
    handleSkuSearch(query){
      this.getSkuList(query)
    },
    async getSkuList(query=null) {
      const res = await fetchSkuPage({
         customerCodes: this.warehouseCustomerList.length?this.warehouseCustomerList.map(item=>item.code):[],
        // customerTenantId:this.record.tenantId,
        loginCustomerCode: this.record.customerCode,
        unionCondition:query||null,
        needProjectContentCheck: true,
        neProjectId:this.record.id,
        status: 1,
        deleteStatus: 0,
        ignoreTenantId: true
      })
      this.skuList = res.records.map(item => {
        return {
          ...item,
          code: item.skuCode,
          name: item.skuName
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    clickErea() {
      this.$refs.stationDrawer.show(this.areaValue)
    },
    serialize(data){
      return JSON.parse(JSON.stringify(data))
    },
    async show(record) {
      const { creditCode, customers } = this.$store.state.user
      if (creditCode) {
        const choose = customers.find(item => item.customerCode === record.customerCode) || {}
        const select = this.TenantList.find(item => item.id === choose.customerId)
        const {carrierTenantId,carrierTenantName,id,customerCode,customerName} = select || {}
        const selectCarriering = {
          tenantId:carrierTenantId,
          tenantName:carrierTenantName,
          customerId:id,
          customerCode,
          customerName,
        }
        Object.keys(selectCarriering).forEach(item=>{
          this.SET_USER_DATA([item,selectCarriering[item]])
        })
      }
      this.record = record
      await this.getWarehouseCustomer()
      this.getWarehouseList()
      
      const res = await getProjectContentDetail({
        projectId: record.id,
        customerCode:record.customerCode
      })
      if(!res.projectId){
        this.getSiteList()
        this.getLineList()
        this.getSkuList()
      }else{
        const {lineValue,skuValue,stationValue} =res.contentValue;
        this.siteList = this.serialize(stationValue);
        this.selectSiteList = this.serialize(stationValue);
        this.lineList = this.serialize(lineValue);
        this.selectLineList = this.serialize(lineValue);
        this.skuList = this.serialize(skuValue);
        this.selectSkuList =  this.serialize(skuValue);
      }
      const { areaValue, ...other } = res.contentValue || {}
      const params = {}
      Object.keys(other || {}).forEach(item => {
        if (other[item]?.length) {
          params[item] = other[item].map(i => i.code)
        }
      })
      this.form = {
        ...res,
        type: res.type || CreateTypeList[0].value,
        contentValue: params
      }
      this.areaValue = areaValue || []
      this.visible = true
    },
    async onSubmit() {
      // let notNone = 0
      // this.requireList.forEach(item => {
      //   if (this.form.contentValue[item] && this.form.contentValue[item].length) {
      //     notNone += 1
      //   }
      // });
      // if (this.areaValue.length) {
      //   notNone += 1
      // }
      // if (!notNone) {
      //   this.$message.warning('应用条件至少选择其中一项')
      //   return
      // }
      const { contentValue, ...other } = this.form
      const { customerCode,projectCode,projectName,id } =this.record;
      const params = {
        ...other,
        customerCode,
        projectId:id,
        projectCode,
        projectName,
        contentValue: {
          areaValue: this.areaValue
        }
      }
      Object.keys(contentValue).forEach(item => {
        if (contentValue[item].length) {
          const list = this.contentValueList[item]
          params.contentValue[item] = this[list].filter(i => contentValue[item].includes(i.code)).map(child => {
            return {
              code: child.code,
              name: child.name
            }
          })
        }
      })
      await upsertProjectContent(params)
      this.$message.success('保存成功')
      this.onClose()
    },
    onClose() {
      this.record = {}
      this.form = {
        type: CreateTypeList[0].value,
        contentValue: {}
      }
      this.areaValue = []
      this.visible = false
    },
    changeErea(areaValue) {
      this.areaValue = areaValue
    },
  }
}
</script>

<style lang="less" scoped>
.auto-application {
  /deep/ .ant-drawer-title {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    width: 400px;
  }
  /deep/ .ant-drawer-body {
    height: calc(100% - 125px);
    overflow-y: auto;
  }
  /deep/ .ant-form-item {
    .ant-form-item-label {
      line-height: 22px;
      padding-bottom: 8px;
      > label {
        color: #404B5C;
      }
    }
  }
  .bloc-tips {
    font-size: 13px;
    color: #808792;
    margin-bottom: 16px;
  }
  .drawer-bottom {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    text-align: right;
    padding: 20px 24px;
  }
}
</style>